module.exports = __webpack_public_path__ + "static/img/logo_white.d7799ed4.svg";